// Used for detection of screen dimensions + beta sign in the corner

import React, { useState, useEffect } from "react";

const BetaNewIndicator = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "0",
        right: "0",
        zIndex: 500000,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        opacity: "0.98",
      }}
    >
      <div
        style={{
          width: 0,
          height: 0,
          borderTop: "98px solid transparent",
          borderRight: "98px solid rgba(255, 4, 0, 0.48)",
          position: "relative",
          zIndex: 1,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: "51px",
          right: "0",
          transform: "rotate(-45deg)",
          fontSize: "14px",
          color: "#1ff",
          whiteSpace: "nowrap",
          textShadow: "-4px -2px 7px rgba(0,0,0,1)",
          boxShadow: "33px 29px 13px -12px rgba(18,226,221,1) inset",
          padding: "4px",
          zIndex: 2,
        }}
      >
        NEW BETA!
      </div>
    </div>
  );
};

const ViewportWidthIndicator = () => {
  const [width, setWidth] = useState(window.innerWidth); // Init width
  const [height, setHeight] = useState(window.innerHeight); // Init height

  // Getting window size
  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== width) {
        setWidth(newWidth);
      }

      if (newHeight !== height) {
        setHeight(newHeight);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty array of dependacies equals single exectution upon deploying component

  return (
    <div
      style={{
        position: "fixed",
        bottom: "0",
        left: "90px",
        transform: "translate(-35%, 0)",
        padding: "6px",
        opacity: "94%",
        fontSize: "15px",
        color: "#FF0000",
        backgroundColor: "#FFF",
        outline: "2px solid red",
        textAlign: "center",
        boxShadow: "0 0 5px rgba(0, 0, 0, 0.28)",
        zIndex: 2100000,
      }}
    >
      w: {width}px / h: {height}px
    </div>
  );
};

const App = () => {
  return (
    <div>
      <BetaNewIndicator />
      <ViewportWidthIndicator />
    </div>
  );
};

export default App;
